const classes = ['neighbor--white', 'neighbor--light', 'neighbor--dark', 'neighbor--black'];

function moveTags(container) {
  container.querySelectorAll('shopify-section').forEach((element) => {
    element.classList.remove(classes);
  });
  container.querySelectorAll('.section.bg--neutral').forEach((element) => {
    element.parentElement.classList.add('neighbor--white');
  });
  container.querySelectorAll('.section.bg--accent').forEach((element) => {
    element.parentElement.classList.add('neighbor--light');
  });
  container.querySelectorAll('.section--dark.bg--invert').forEach((element) => {
    element.parentElement.classList.add('neighbor--dark');
  });
  container.querySelectorAll('.section--dark.bg--invert--accent').forEach((element) => {
    element.parentElement.classList.add('neighbor--black');
  });
}

export default moveTags;
